export default Promise.resolve({
  amount: 1,
  base: "EUR",
  date: "2021-10-05",
  rates: {
    AUD: 1.5937,
    BGN: 1.9558,
    BRL: 6.3106,
    CAD: 1.4612,
    CHF: 1.0752,
    CNY: 7.4805,
    CZK: 25.308,
    DKK: 7.4379,
    GBP: 0.85173,
    HKD: 9.0324,
    HRK: 7.505,
    HUF: 356.9,
    IDR: 16507,
    ILS: 3.7477,
    INR: 86.49,
    ISK: 148,
    JPY: 128.99,
    KRW: 1376.12,
    MXN: 23.79,
    MYR: 4.8482,
    NOK: 9.9155,
    NZD: 1.665,
    PHP: 58.893,
    PLN: 4.5998,
    RON: 4.9477,
    RUB: 84.15,
    SEK: 10.131,
    SGD: 1.5743,
    THB: 39.203,
    TRY: 10.2707,
    USD: 1.1602,
    ZAR: 17.3792,
  },
});
